import { Component, OnInit, ViewChild } from '@angular/core';
import { AdminService } from '../../services/admin';
import { Router } from '@angular/router';
import { Prescription } from 'model/prescription';
import { Ordonnance } from 'model/ordonnance';
import { Consultation } from 'model/consultation';
import { Repos } from 'model/repos';
import { Agenda } from 'model/model.agenda';
import { RendezVous } from 'model/rendezvous';
import { ExamenSuplementaire } from 'model/examenSuplementaire';
import { Examen } from 'model/examen';
import { Popup } from 'ng2-opd-popup';
import { Categorie } from 'model/categorie';
import { StockClient } from 'model/stock-client';
import { Ophtalmo } from 'model/ophtalmo';
import { Employer } from 'model/model.employer';
import { Actes } from 'model/actes';
import { Stockurgent } from 'model/stockurgent';
import { Epidemimie } from 'model/modal-cms/epidemie';
import { CMSService } from '../../services/cms-service';
import { environment } from 'environments/environment';
declare var mdtoast: any;
declare var $;
var success_message = mdtoast("Opération effectué avec succès. En attante de validation par le Médecin", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var error_message = mdtoast('Opération non effectué.', { duration: 5000, init: true, type: mdtoast.ERROR });
var info_message = mdtoast('Opération non effectué. Ce donnée est en cours d\'utilisation.', { duration: 5000, init: true, type: mdtoast.INFO });


@Component({
  selector: 'app-mes-historique',
  templateUrl: './mes-historique.component.html',
  styleUrls: ['./mes-historique.component.scss']
})
export class MesHistoriqueComponent implements OnInit {
  listeHistoriqueConsultation2: Array<Consultation>;
  listeHistoriqueConsultation: Array<Consultation>;
  consultation_detail: any;
  consultation: Consultation;
  repos: Repos = new Repos();
  agenda: Agenda;
  reposagents: any;
  examenSuplementaire: ExamenSuplementaire = new ExamenSuplementaire();
  //  examen :Examen;
  newDocument: Document = new Document();
  rendezVous: RendezVous = new RendezVous();
  rendez_vous_date: Date = new Date();
  prescription: Prescription = new Prescription();
  ordonnance: Ordonnance = new Ordonnance(null, null, null, null);
  pageRepos: any;
  pageOrdonance: any;
  @ViewChild('popup5') popup5: Popup;
  nom_patient: string = "";
  date_detail_consultation: Date = new Date();
  idpatient: number;


  pageConsultationApres: Array<Consultation>;
  motCle: String = "";
  currentPage: number = 1;
  size: number = 10;
  pages: Array<number>;
  id_employer: number;
  listestockurgenttraite: Array<Stockurgent>;

  aa: any;
  pageExament: any;
  pageDocument: any;
  pageRendezVous: any;
  pageCertificat: any;
  id_consultation: any;
  tempPrescription: Prescription;
  categorie_id: any;
  categories: Array<Categorie>;
  stock: StockClient;
  medicaments: any;
  modif: boolean;
  modifPrescription: boolean;
  qteANT: number;
  qteTSZ: number;
  qteAEP: number;
  saisieANT: number;
  saisieTSZ: number;
  saisieAEP: number;
  saisieEXT: number;
  totalsaisiePH: number;
  prescriptionMM: Array<Prescription>;
  medicament_old_id: number;
  modifOphtalmo: boolean = false;
  ophtalmoTemp: Ophtalmo;
  examen: Examen = new Examen(null, null);
  medecinEx: Array<Employer> = new Array<Employer>();
  newActe: Actes = new Actes();

  //chart
  // public doughnutChartLabels = ['03 jan 2020', '15 jan 2020' , '03 fév 2020'];
  // public doughnutChartData = ["2", "1", "3"];
  // public doughnutChartType = 'doughnut';

  mode_patient: number = 10;
  mode_title: number = 10;
  mode_repos: number = 1;
  id_consultation2: number = 29032;
  //mm Tina : 340909  r =  	102 092 018 294
 // id_agent_actuel: any = "340909";
 id_agent_actuel: any;
  listeFamille: any = " ";
  im_agenda_selected: any;
  modeAgentEtFamille: number;
  //agent_iscrit: any;

  @ViewChild('popupalert') popupalert: Popup;
  epidemimie: Epidemimie = new Epidemimie(null);
  nbr_covid19: any;
  date_covid19: Date;

  statistique_actu : any ;

   urllogoIec = environment.urllogoIec;

  constructor(private router: Router, public cmsService: CMSService, public adminService: AdminService) {
    // this.idpatient = activatedRoute.snapshot.params['consultation_id'];
    this.id_agent_actuel = this.adminService.getUserIMIscrit();
   
    this.ordonnance;
    this.consultation = new Consultation(null, null, null, null, null, null);
    //  this.id_consultation=activatedRoute.snapshot.params['id'];
    this.agenda = new Agenda(null, null, null);
  }

  ngOnInit() {
    this.getinfoipdemie()
    this.recupererAgentFamille();
    this.recupererConsultation(30385);

   }


   popupnew() {
    this.popupalert.options = {    
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-danger",
      color: "#FF0000",
      showButtons: true,
      animationDuration: 2,
      header: "ALERT COVID-19",
      widthProsentage: 50,
      animation: "fadeInDown",
      confirmBtnContent: "En savoir plus",
      cancleBtnContent: "Fermer",
    }
  
    this.popupalert.show(this.popupalert.options);
   // this.getinfoipdemie();
  }

  voir(){
  if(this.adminService.getLoginUseCMS() == "com_daf"){
       this.router.navigate(['iec-epidemie']);
    }else{
     
       this.router.navigate(['landing']);
    }
  }

  

  
  getinfoipdemie() {
    let etat="ACTU"
    this.cmsService.getInfoEvolutionEpidemiebyetet(etat)
      .subscribe(data => {           
        this.epidemimie = data
        this.nbr_covid19  =  this.epidemimie.text_epid 
        this.date_covid19 =  this.epidemimie.date_ajout 
        if(this.epidemimie.image_actu == null){
          this.statistique_actu = "alerte_corona.PNG";
          this.popupnew();         
        }else{
          this.statistique_actu = this.epidemimie.image_actu;
          this.popupnew();
        }
      },
        err => {
          console.log(err);
        })
  }
  




  //http://10.2.250.161:7001/cms/ws/agent_et_famille?im=340909   cas ecd
  // this.adminService.getlisteFamille(this.id_agent_actuel)
  recupererAgentFamille() {
    this.adminService.getlisteFamille(this.id_agent_actuel)
      .subscribe(data => {
        if (data.length ==0 ) {              
          this.listeFamille = []
          this.modeAgentEtFamille = 1
        } else if (data.length !=0){
          this.modeAgentEtFamille = 2
          this.listeFamille = data;        
        }

      }, err => {

      })
  }



  //get list consultatio by agent
  recupererHistoriqueConsultation_olde(idAgent: number) {
    this.adminService.getConsultationParConjoint(idAgent)
      .subscribe(data => {
        this.listeHistoriqueConsultation = data;
      }, err => {

      })
  }

 

  afficherMedicamentLibelle(p: Prescription) {
    var retour = "";
    if (!p.medicament_id || p.medicament_id == -1) return p.prescription_medicament_lib;
    return p.medicament.medicament_libelle;
  }

  afficherMedicamentDosage(p: Prescription) {
    var retour = "";
    if (!p.medicament_id || p.medicament_id == -1) return p.prescription_dose;
    return p.medicament.medicament_dosage;
  }



  afficherModalDelPrescription(p: Prescription) {
    this.prescription = p;
    $('#popup_confirm_delete').modal('show');
  }

  changerMDC(petit_client) {
    if (petit_client == 'MDC') return 'ANT';
    else if (petit_client == 'AEP') return 'ANS';
    else return petit_client;
  }




  ouvrirDetailConsultation2(id: number) { //id consultation
    this.consultation_detail = new Consultation(null, null, null, null, null, null);
    this.adminService.getConsultationById(id).subscribe(data => {
      if (data.err) {
        //toastr.error(data.err);
        return;
      }
      this.consultation_detail = data;
    }, err => {

    });
    this.listePatientDonnerOrdonnance();
    this.listePatientGagneRepos();
  }

  listePatientDonnerOrdonnance() {
    this.adminService.getlistePatientDonnerOrdonnance()
      .subscribe(data => {
        this.pageOrdonance = data;
        console.log(data);
      }, err => {
        console.log(err);
      })
  }

  listePatientGagneRepos() {
    this.adminService.getlistePatientGagneRepos()
      .subscribe(data => {
        this.pageRepos = data;
        console.log(data);
      }, err => {
        console.log(err);
      })
  }


  open(id_patient: number,nom:any, prenom:any) {
    if (id_patient == 1) {
      this.mode_patient = 1;
      this.nom_patient = nom +" "+ prenom
      //  this.id_employer=this.userService.getUserId();
      this.pageConsultationApres = new Array<Consultation>();
    } else if (id_patient == 2) {
      this.mode_patient = 2;
      this.nom_patient = nom +" "+ prenom
    } else if (id_patient == 3) {
      this.mode_patient = 3;
      this.nom_patient = nom +" "+ prenom
    }
    this.mode_title = 1;
  }


  infoRepos(id_repos: number) {
    if (id_repos == 1) {
      this.mode_repos = 1;
    } else {
      this.mode_repos = 2;
    }
  }





  ouvrirDetailConsultation(id_c: any) {
    if (id_c == null) {
      this.recupererConsultation(28889);
      
    } else {
      this.recupererConsultation(id_c);
    }

    this.prescription = new Prescription();
    this.categories = new Array<Categorie>();
    this.recupererListeCategorie();
    this.recupererListMedecinExaminateur();
    this.modif = false;


    this.popup5.options = {
      cancleBtnClass: "btn btn-danger",
      confirmBtnClass: "btn btn-success",
    color: "#0F7B79 ",
      showButtons: true,
      animationDuration: 1.5,
      header: "Historique de patient " + this.nom_patient,
      widthProsentage: 80,
      animation: "fadeInRight",
      cancleBtnContent: "Fermer",
      confirmBtnContent: "Retour"
    }

    this.popup5.show(this.popup5.options);
  }



  // consultation par id (29032)  soloina    Consultation par Matricule ()   
  recupererConsultation(id: number) {
    this.adminService.getConsultationById(id).subscribe(data => {
      if (data.length ==0 ){  
        return data;
         }else{
          this.consultation = data;
          if (this.consultation.ophtalmo)
            this.ophtalmoTemp = { ... this.consultation.ophtalmo };
          this.agenda = this.consultation.agenda;
    
         }
   
    }, err => {

    })
  }

  recupererHistoriqueConsultationAgent(matricule: any) {
    this.im_agenda_selected = matricule;
    this.recupererConsultation(this.im_agenda_selected)

  }

  //8697    Ronnah = 12284

  recupererHistoriqueConsultation(matricule: any) {
    this.im_agenda_selected = matricule;
    this.getListStatistiqueReposAgent();
  //  this.adminService.getConsultationParConjoint(8697)
  this.adminService.getConsultationParConjoint(this.im_agenda_selected )
      .subscribe(data => {
        this.listeHistoriqueConsultation2 = data;
        console.log("tafa2 eeeeee" + this.listeHistoriqueConsultation2)
      }, err => {

      })
  }

  //get repos 340909
  getListStatistiqueReposAgent() {
    this.adminService.getListeReposAgent(this.id_agent_actuel).subscribe(data => {
      this.reposagents = data;
      console.log("aiza nareo eeeee" + this.reposagents)
    }, err => {

    })
  }


  recupererListeCategorie() {
    this.adminService.getCategories().subscribe(data => {
      this.categories = data;
    }, err => {

    })
  }

  recupererListMedecinExaminateur() {
    this.adminService.getMedecin("MEX", 0, 10)
      .subscribe(data => {
        if (data.err) {
          data.err.show(); return;
        }
        this.medecinEx = data;


      }, err => {
        console.log(err);
      })

  }





}
